import * as _ from 'lodash';

export const environmentBase = {
  production: false,
  apiUrl    : '/',
  restApiUrl: _.get(window, 'REST_API_URL', ''),
  api_key   : REG_API_KEY,
  password  : REG_API_PWD,
};


// WEBPACK FOOTER //
// ./environments/environment_base.js